import {
  GET_NOTIFICATION_EVENTS,
  GET_NOTIFICATION_EVENT_DETAIL,
  CREATE_NOTIFICATION_EVENT,
  UPDATE_NOTIFICATION_EVENT,
  DELETE_NOTIFICATION_EVENT,
  DUPLICATE_NOTIFICATION_EVENT,
  GET_NOTIFICATION_TRIGGERS,
  GET_NOTIFICATION_RECIPIENTS,
  GET_MODULE_TYPES,
} from "@/api/settings/notification-event";

const handleRequest = async (apiFunc, commit, mutation, args, emptyValue = []) => {
  try {
    const resp = await apiFunc(args);
    const { httpCode, data } = resp.data;

    if (httpCode === 200) {
      if (data?.data && data?.totalItems !== undefined) {
        commit(mutation, {
          data: data.data,
          total: data.totalItems,
          page: data.page,
          limit: data.limit,
          totalPages: data.totalPages,
        });
      } else {
        commit(mutation, data);
      }
      return data;
    }

    commit(mutation, emptyValue);
    return emptyValue;
  } catch (err) {
    const resp = err?.response?.data;
    if (resp?.httpCode === 404) {
      commit(mutation, emptyValue);
    }
    throw err;
  }
};

const state = {
  notificationEvents: {
    data: [],
    total: 0,
    page: 1,
    limit: 10,
    totalPages: 1,
  },
  notificationEventDetail: null,
  createdNotificationEvent: null,
};

const mutations = {
  setNotificationEvents: (state, payload) => {
    state.notificationEvents = {
      data: payload.data || [],
      total: payload.total || 0,
      page: payload.page || 1,
      limit: payload.limit || 10,
      totalPages: payload.totalPages || 1,
    };
  },
  setNotificationEventDetail: (state, payload) => (state.notificationEventDetail = payload),
  setCreatedNotificationEvent: (state, payload) => (state.createdNotificationEvent = payload),
};

const actions = {
  async getNotificationEvents({ commit }, query) {
    return handleRequest(GET_NOTIFICATION_EVENTS, commit, "setNotificationEvents", query, []);
  },

  async getNotificationEventDetail({ commit }, id) {
    return handleRequest(GET_NOTIFICATION_EVENT_DETAIL, commit, "setNotificationEventDetail", id, null);
  },

  async createNotificationEvent({ commit }, data) {
    return handleRequest(CREATE_NOTIFICATION_EVENT, commit, "setCreatedNotificationEvent", data, null);
  },

  async updateNotificationEvent(_, { id, data }) {
    return UPDATE_NOTIFICATION_EVENT({ id, data });
  },

  async deleteNotificationEvent(_, id) {
    return DELETE_NOTIFICATION_EVENT(id);
  },

  async duplicateNotificationEvent(_, id) {
    return DUPLICATE_NOTIFICATION_EVENT(id);
  },

  async getNotificationTriggers(_) {
    const responses = await GET_NOTIFICATION_TRIGGERS();

    return responses.data.data;
  },

  async getNotificationRecipients(_) {
    const responses = await GET_NOTIFICATION_RECIPIENTS();

    return responses.data.data;
  },

  async getModuleTypes(_) {
    const responses = await GET_MODULE_TYPES();

    return responses.data.data;
  },
};

const getters = {
  notificationEvents: (state) => state.notificationEvents,
  notificationEventDetail: (state) => state.notificationEventDetail,
  createdNotificationEvent: (state) => state.createdNotificationEvent,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
